import { enqueueSnackbar, UploadFile, DownloadFile } from 'actions';

import { FocusOccasionUploadRequest, DownloadTemplateRequest } from '../requests/FocusOccasionUploadRequests.js';

export const RET_ENABLING_CHECKS = 'RET_ENABLING_CHECKS';
export const SET_FORM_STATE = 'SET_FORM_STATE';

export const DownloadTemplate = (userName, userId) => async (dispatch) => {
	await DownloadTemplateRequest(userName, userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const UploadFocusOccasionFiles = (filePath, userName, userId) => async (dispatch) => {
	await FocusOccasionUploadRequest(filePath, userName, userId).then(response => {
		dispatch(enqueueSnackbar({ message: response.data, options: { variant: 'success' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const RunFileUpload = (file, userName, userId) => async (dispatch) => {
	await UploadFile(file).then(response => {
		dispatch(UploadFocusOccasionFiles(response.data, userName, userId));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};
